import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { PageHint } from '@/components/HelpText';
import { HELP_TOPICS } from '@/content/help';

export function HelpPage() {
  const location = useLocation();

  // deep-link: /help#cartoes rola até o tópico
  useEffect(() => {
    const id = location.hash.replace('#', '');
    if (!id) return;
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [location.hash]);

  return (
    <div className="flex flex-col gap-4">
      <header>
        <h1 className="text-xl font-semibold">Ajuda</h1>
      </header>

      <PageHint>
        Guia rápido de como o app funciona, em linguagem simples. Cada tela também tem um botão{' '}
        <strong>?</strong> que abre o tópico daquela tela.
      </PageHint>

      <nav className="flex flex-wrap gap-2">
        {HELP_TOPICS.map((t) => (
          <a
            key={t.id}
            href={`#${t.id}`}
            className="tap rounded-full border border-slate-300 px-3 py-1.5 text-sm text-slate-600 hover:border-slate-900 hover:text-slate-900"
          >
            {t.icon} {t.title}
          </a>
        ))}
      </nav>

      <div className="flex flex-col gap-4">
        {HELP_TOPICS.map((t) => (
          <section
            key={t.id}
            id={t.id}
            className="scroll-mt-20 rounded-xl border border-slate-200 bg-white p-5 shadow-sm"
          >
            <h2 className="mb-1 text-base font-semibold">
              {t.icon} {t.title}
            </h2>
            <p className="mb-3 text-sm text-slate-500">{t.summary}</p>
            {t.body}
          </section>
        ))}
      </div>
    </div>
  );
}
